/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import {
    bool, func, object, string,
} from 'prop-types';
import { makeStyles, useMediaQuery } from '@material-ui/core';
import { EXTERNAL_TAB_KEYS, sendStatusToExternalTab } from '../utils/multipleTabsChat';

const useStyles = makeStyles((theme) => ({
    menuModal: {
        position: 'absolute',
        bottom: '30px',
        width: '100%',
        zIndex: 2,
        padding: '0 30px',
    },
    mediaModalDialog: {
        maxWidth: '100%',
        margin: '0 auto',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff !important',
        border: '1px solid rgba(0,0,0,.2)',
        borderRadius: '.3rem',
        outline: '0',
    },
    menuModalDialog: {
        maxWidth: '100%',
        margin: '0 auto',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff !important',
        border: '1px solid rgba(0,0,0,.2)',
        borderRadius: '.3rem',
        outline: '0',
    },
    menuModalContent: {
        backgroundColor: '#fff',
        boxShadow: '0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)',
    },
    endChatButton: {
        display: 'block',
        color: `${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        width: '100%',
        border: 'none',
        fontSize: '16px',
        padding: '5px 10px',
        textAlign: 'left',
        backgroundColor: '#fff',
        fontFamily: 'Arial, sans-serif',
        '&:hover': {
            backgroundColor: '#eaeaec',
        },
    },
    openEmailTranscriptButton: {
        display: 'block',
        color: `${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        width: '100%',
        border: 'none',
        fontSize: '16px',
        padding: '5px 10px',
        textAlign: 'left',
        backgroundColor: '#fff',
        fontFamily: 'Arial, sans-serif',
        '&:hover': {
            backgroundColor: '#eaeaec',
        },
    },
    buttonWrappingDiv: {
        display: 'block',
        maxWidth: '100%',
        padding: '10px',
        '& button': {
            cursor: 'pointer',
        },
    },
}));

const MenuThreeDotDialog = ({
    showThreeDotMenu,
    openEmailTranscriptInputDialog,
    closeChatAndCleanUpSession,
    chatWidgetMinimized,
    featureFlags,
    convId,
    mainTabConvID,
    dummyTabId,
}) => {
    const [responsiveModalDialogClass, setResponsiveModalDialogClass] = useState(undefined);
    const matches = useMediaQuery('(min-width: 576px)');
    const classes = useStyles();
    /**
     * Adjust modal styles to match the current resolution.
     */
    useEffect(() => {
        if (matches) {
            setResponsiveModalDialogClass(classes.mediaModalDialog);
        } else {
            setResponsiveModalDialogClass(classes.menuModalDialog);
        }
    }, [matches]);

    const handleOnCloseChat = () => {
        closeChatAndCleanUpSession();
        sendStatusToExternalTab(EXTERNAL_TAB_KEYS.ON_CLOSE_DIALOG, convId || mainTabConvID, !!convId, dummyTabId, '', featureFlags);
    };

    return (showThreeDotMenu && !chatWidgetMinimized ? (
        <div id="threeDotMenu" className={classes.menuModal}>
            <div className={responsiveModalDialogClass}>
                <div className={classes.menuModalContent}>
                    <div className={classes.buttonWrappingDiv}>
                        {featureFlags['is-send-chat-transcript-email-enabled'] && <button type="button" data-testid="email-transcript" className={classes.openEmailTranscriptButton} onClick={() => openEmailTranscriptInputDialog()}>Email Transcript</button>}
                        <button type="button" data-testid="end-chat" className={classes.endChatButton} onClick={handleOnCloseChat}>End Chat</button>
                    </div>
                </div>
            </div>
        </div>
    ) : null);
};

MenuThreeDotDialog.propTypes = {
    showThreeDotMenu: bool.isRequired,
    openEmailTranscriptInputDialog: func.isRequired,
    closeChatAndCleanUpSession: func.isRequired,
    chatWidgetMinimized: bool.isRequired,
    featureFlags: object.isRequired,
    convId: string,
    mainTabConvID: string,
    dummyTabId: string,
};

MenuThreeDotDialog.defaultProps = {
    convId: '',
    mainTabConvID: '',
    dummyTabId: '',
};

export default MenuThreeDotDialog;
